import { memo } from "react";
import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
const SvgWarning = (props: SvgProps) => (
  <Svg width={46} height={41} fill="none" {...props}>
    <Path
      fill="#F49090"
      d="M44.587 33.318 27.237 2.944a4.93 4.93 0 0 0-1.796-1.79 4.88 4.88 0 0 0-4.88 0 4.93 4.93 0 0 0-1.796 1.79L1.415 33.318a4.73 4.73 0 0 0 0 4.744 4.85 4.85 0 0 0 1.79 1.797c.745.429 1.589.65 2.446.64h34.7c.857.009 1.7-.212 2.444-.64a4.85 4.85 0 0 0 1.788-1.797 4.73 4.73 0 0 0 .004-4.744M21.414 16.5c0-.424.167-.831.465-1.131a1.58 1.58 0 0 1 2.244 0c.298.3.465.707.465 1.131v8c0 .424-.167.831-.465 1.131a1.58 1.58 0 0 1-2.244 0 1.6 1.6 0 0 1-.465-1.131zM23 34.1c-.47 0-.931-.141-1.323-.405a2.4 2.4 0 0 1-.877-1.077 2.42 2.42 0 0 1 .517-2.615 2.363 2.363 0 0 1 2.595-.52c.434.181.806.489 1.068.883a2.414 2.414 0 0 1-.297 3.03 2.37 2.37 0 0 1-1.683.704"
    />
  </Svg>
);
const Memo = memo(SvgWarning);
export default Memo;
